var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],class:['modal']},[_c('div',{ref:"component",staticClass:"component fade-in-up"},[_c('button',{staticClass:"close",on:{"click":_vm.closeModal}}),_c(_vm.modal.component,{tag:"component"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }